import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import selectn from "selectn";

import StoryHeader from "../StoryHeader";
import StoryContent from "../StoryContent";
import StoryFooter from "../StoryFooter";
import ErrorBoundary from "components/Library/ErrorBoundary";
import ogImg from "assets/img/social-default.png";
import logo from "assets/img/large-logo.png";

import styles from "./StoryCard.css";
import { FACTS_MATTER_TEMPLATE } from "../../../config/constants";

class StoryCard extends Component {

  generateJSONLD(story) {
    const image = (story.primary_image && story.primary_image.base_image_url) ||
      (story.social_image && story.social_image.base_image_url) ||
      ogImg;
    const authors = story.authors.map((author) => ({
      "@type": "Person",
      "name": author.display_name,
    }));

    return (`<script type="application/ld+json">
      ${JSON.stringify({
        "@context": "http://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": story.permalink,
        },
        "headline": story.headline,
        image,
        "datePublished": story.published_date,
        "author": authors,
        "publisher": {
          "@type": "Organization",
          "name": "Axios",
          "logo": {
            "@type": "ImageObject",
            "url": logo,
          },
        },
        "description": story.og_description,
        "articleSection": story.primary_section && story.primary_section.name,
      })}
    </script>`);
  }

  render() {
    const { story, hideHeader, hideFooter, header, storyType, permalinkId, index } = this.props;
    if (!story) return null;

    return (
      <ErrorBoundary>
        <div
          id={story.id}
          className={classNames(
            "story-card",
            styles.root,
            this.props.className,
            story.slideIn ? styles.slideIn : {},
            (story.template === FACTS_MATTER_TEMPLATE && styles.factsMatter) ||
            (story.is_featured && !selectn("rubric.name", story) && styles.featured),
          )}>
          {storyType !== "newsletter" && <div dangerouslySetInnerHTML={{ __html: this.generateJSONLD(story) }} />}
          <div className={classNames("permalink", styles.hide)}>{story.permalink}</div>
          {!hideHeader && (header || <StoryHeader story={story}/>)}
          <StoryContent story={story} storyType={storyType} permalinkId={permalinkId} index={index} />
          {!hideFooter && <StoryFooter story={story}/>}
        </div>
      </ErrorBoundary>
    );
  }
}

StoryCard.propTypes = {
  story: PropTypes.object,
  storyType: PropTypes.oneOf(["newsletter"]),
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
  header: PropTypes.element,
  className: PropTypes.string,
  permalinkId: PropTypes.string,
};

export default StoryCard;
